import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'
import { CaseCTAItem } from 'components/cases/common/CaseCTA'

// ファーストビュー
export const firstViewItemWhite = {
  breadcrumb: '運用工数&コストの削減をデザインシステム導入で実現',
  title1: '運用工数&コストの削減をデザインシステム導入で実現',
  company: '株式会社マクロミル',
  introduction_text:
    'マクロミル様のデザインシステム構築を支援しました。これは、複数のシステムを横断する顧客体験の一貫性と、プラットフォーム再構築におけるシステム開発効率の向上を実現するプロジェクトです。弊社は、デザイン原則の策定からFigmaコンポーネントライブラリの構築、運用フェーズにおける改善・最適化まで、伴走支援を行いました。',
  tag1text: 'デザインシステム構築支援',
  tag1src: '/cases/design-system/',
  industryTagText: 'IT/情報/通信',
  industryTagSrc: '/cases/telecommunications/',
  image: '/images/img/cases/macromill-designsystem/mv.webp',
  movie: '',
  alt: '運用工数&コストの削減をデザインシステム導入で実現',
}

// プロジェクト概要
export const overviewTitle = '膨大なUI要素を整理統合し、実用性の高いデザインシステムの構築・運用を支援'

export const overviewItem: OverviewItems[] = [
  {
    text: '企業の成長に伴い、プロダクト数が増えると、UIの一貫性を維持することが難しくなります。しかし、それぞれのプロダクトが異なるデザインや操作性を持つと、ユーザーにとって使い勝手が悪くなるだけでなく、ブランド全体の印象にも影響を及ぼします。さらに、運用や保守にかかるコストや工数も増大し、開発現場への負担も大きくなります。',
  },
  {
    text: '創立25周年を迎えるマクロミルも、まさにこうした課題に直面していました。これを解決すべく、同社はシステム部門にデザイン組織を立ち上げ、デザインシステムを導入して複数のシステムを横断する顧客体験の一貫性と、システム開発効率の向上を実現するプロジェクトを始動。',
  },
  {
    text: 'アイスリーデザインは、このデザインシステム構築プロジェクトにおいて、デザイン原則やビジュアルテーマの再設計から、Figmaコンポーネントライブラリの構築までを一貫して支援。特に、デザインシステムを「創るだけ」で終わらせず、実際に使用する人が快適に運用できることを重視。既存プロダクトを棚卸しし、必要なコンポーネントを厳選して絞り込むプロセスや、運用フェーズでの改善・最適化に力を入れました。',
  },
  {
    text: '今回は、プロジェクトを統括するマクロミルの森本さんに加え、アイスリーデザインからはプロジェクトマネージャーの今野、デザイン部の部長として監修を務めた佐々木、UIデザイナーの岩本と原田の5名にお話を伺いました。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: 'UI・操作性のバラつきによる学習・運用コストの増大',
        text: '各事業部が独自にデザインコンペを行い、異なるデザイン会社に依頼していた結果、複数プロダクトのUIや操作性が統一されておらず、ユーザーは各プロダクトの操作方法を覚える必要があり、学習コストやオペレーションコストが増大していた。',
      },
      {
        title: 'システム管理の複雑化と高コスト化',
        text: '個別に構築されたインフラやミドルレイヤー、デザインが肥大化し、システムの管理が煩雑になり、管理コストが高騰していた。',
      },
      {
        title: 'デザインガバナンスの欠如',
        text: 'システム部門内にデザイン組織がなく、デザインのガバナンス（統制）が機能しておらず、プロジェクトごとにデザイン品質のばらつきが発生していた。',
      },
    ],
    solutions: [
      {
        title: 'デザインシステム導入によるUI・UXの統一化',
        text: 'UI要素をコンポーネント化したデザインライブラリを構築し、コードライブラリと連携させてそれらのパーツを組み合わせることで、各プロダクトで一貫したUI・UXの制作が実現可能になった。',
      },
      {
        title: 'システム運用の効率化と管理コストの削減',
        text: 'プラットフォームの刷新に合わせてデザインシステムと連携することで、システム全体の管理負担を軽減し、運用コストを削減した。',
      },
      {
        title: 'デザインガバナンスの強化を支援',
        text: 'ワークショップを通じ、デザインに関わる関係者や上層部も巻き込み、プロジェクトの合意形成を推進。デザインシステム導入に向けた関係者の意見を収集し、社内外の調整役としてサポートした。',
      },
    ],
  },
]

// CTA
export const caseCTAItem: CaseCTAItem = {
  title: 'UIのバラつき、放置していませんか？',
  description:
    'デザイン原則の策定からコンポーネントライブラリの構築・運用改善まで一貫して伴走し、「作って終わり」にしないデザインシステムをご支援します。まずは、現在の課題やお悩みをお聞かせください。',
}

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
